<template>
    <b-overlay :show="showoverlaymodal" rounded="sm" class="h-100 overlay-posisition"> <!-- Rejwan: 05-02-2026 Comment Mail Sending -->
    <div class="h-100">

        

            <b-card  header-tag="header" footer-tag="footer" class="comment_thread">
                <template #footer>
                    <b-form @submit.stop.prevent="onSubmitThread">
                        <div class="row">
                            <div class="col-sm-12 mt-1 mb-1">   
                                <b-input-group  class="mt-3">
                                    <b-form-file id="upload_file" v-model="upload_file" accept=".jpg, .png, .gif, .pdf , .doc , .docx" @change="checkFileType($event , 'upload_file' , ['.jpg', '.png', '.gif' , '.pdf','.doc','.docx'])" ref="upload_file" placeholder="Attach File" multiple  :file-name-formatter="formatNames" style="border-right: none !important;"><i class="fa-solid fa-paperclip"></i></b-form-file>
                                    <span class="file-count-custom" v-if="upload_file.length > 0">{{upload_file.length}}</span>
                                    <b-form-input v-model="fdata.comment" placeholder="Add a comment"></b-form-input>
                                    <b-input-group-append>
                                    
                                    <b-button variant="primary" type="submit" :disabled="fdata.comment == '' && upload_file == ''">Send</b-button>
                                    </b-input-group-append>
                                </b-input-group>
                            </div>  
                        </div>  
                    </b-form>
                </template>
                <b-card-body class="comment-card-body" id="messageBody">
                    <template  v-if="discussions.length > 0">
                    <template  v-for="item in discussions">
                    <div class="card-body p-4" v-if="item.self == 0">
                        <div class="d-flex flex-start">
                            <!-- <img class="rounded-circle shadow-1-strong me-3 mr-2" style="border: 1px solid #000;"
                            v-bind:src="pageurl+'/images/employee/demo.jpg'" alt="avatar" width="45"
                                height="45" /> -->
                            <img v-if="item.commented_by_type == 0" class="rounded-circle shadow-1-strong me-3 mr-2" style="border: 1px solid #000;"
                            v-bind:src="pageurl+'/images/users/'+item.pic" alt="avatar" width="45"
                                height="45" @error="$event.target.src = pageurl+'/avatar/no-image.jpg'"/> <!-- Rejwan: 23-06-2026 -->
                            <img v-else class="rounded-circle shadow-1-strong me-3 mr-2" style="border: 1px solid #000;"
                            v-bind:src="pageurl+'/avatar/'+item.company_id+'/'+item.pic" alt="avatar" width="45"
                                height="45" @error="$event.target.src = pageurl+'/avatar/no-image.jpg'"/> <!-- Rejwan: 23-06-2026 -->
                            <div class="comment-content">
                                <h6 class="fw-bold mb-1">{{ item.comment_by_name }}</h6>
                                <p class="mb-0">
                                    {{ item.comment }}
                                </p>

                                <template v-if="item.file.length > 0">
                                    <div class="row mx-0">
                                        <div class="col-md-12 text-left pl-0 mb-2 mt-4 attachement_font" style="color:#3A52A6;">Attachments : </div>
                                    </div>
                                    
                                    <template v-for="each_file in item.file"> 
                                        <div class="row mx-0 mb-2">
                                            <!-- <div class="col-md-9 text-left pl-0 attachement_font" style="cursor:pointer;" @click="download_file_new(each_file)">{{ each_file }}</div> -->
                                            <div class="col-md-9 text-left pl-0 attachement_font" style="cursor:pointer;" @click="downloadFileContent('/images/employee/' +company_id+'/'+each_file)">{{ each_file }}</div>
                                            <div class="col-md-3 text-right px-0 icon_download">
                                                <!-- <b-link @click="download_file_new(each_file)" class="mr-0 icon_download_link"> -->
                                                <b-link @click="downloadFileContent('/images/employee/' +company_id+'/'+each_file)">
                                                        <b-icon icon="download" scale="2"></b-icon>
                                                </b-link>
                                            </div>
                                        </div>
                                    </template>

                                </template>
                            </div>
                        </div>
                        </div><div class="card-body p-4" v-else>
                            <div class="d-flex flex-start justify-content-end">
                                <div class="comment-content self-comment">
                                    <h6 class="fw-bold mb-1 d-none">{{ item.comment_by_name }}</h6>
                                    <p class="mb-0">
                                        {{ item.comment }}
                                    </p>

                                    <template v-if="item.file.length > 0">
                                        <div class="row mx-0">
                                            <div class="col-md-12 text-left pl-0 mb-2 mt-4 attachement_font" style="color:#fff;">Attachments : </div>
                                        </div>

                                        <template v-for="each_file in item.file"> 
                                            <div class="row mx-0 mb-2">
                                                <!-- <div class="col-md-9 text-left pl-0 attachement_font" style="cursor:pointer;" @click="download_file_new(each_file)">{{ each_file }}</div> -->
                                                <div class="col-md-9 text-left pl-0 attachement_font" style="cursor:pointer;" @click="downloadFileContent('/images/employee/' +company_id+'/'+each_file)">{{ each_file }}</div>
                                                <div class="col-md-3 text-right px-0 icon_download">
                                                    <!-- <b-link @click="download_file_new(each_file)" class="mr-0 icon_download_link"> -->
                                                    <b-link @click="downloadFileContent('/images/employee/' +company_id+'/'+each_file)" class="mr-0 icon_download_link">
                                                            <b-icon icon="download" scale="2"></b-icon>
                                                    </b-link>
                                                </div>
                                            </div>
                                        </template>

                                    </template>
                                </div>
                                <!-- <img class="rounded-circle shadow-1-strong me-3 mr-0 ml-2" style="border: 1px solid #000;"
                                v-bind:src="pageurl+'/images/employee/demo.jpg'" alt="avatar" width="45"
                                    height="45" /> -->
                                <img v-if="item.commented_by_type == 0" class="rounded-circle shadow-1-strong me-3 mr-0 ml-2" style="border: 1px solid #000;"
                                v-bind:src="pageurl+'/images/users/'+item.pic" alt="avatar" width="45"
                                    height="45" @error="$event.target.src = pageurl+'/avatar/no-image.jpg'"/> <!-- Rejwan: 23-06-2026 -->

                                <img v-else class="rounded-circle shadow-1-strong me-3 mr-0 ml-2" style="border: 1px solid #000;"
                                v-bind:src="pageurl+'/avatar/'+item.company_id+'/'+item.pic" alt="avatar" width="45"
                                    height="45" @error="$event.target.src = pageurl+'/avatar/no-image.jpg'"/> <!-- Rejwan: 23-06-2026 -->
                            </div>
                        </div>
                    </template>
                    </template>
                    <template v-else>
                        <div class="row mx-0 mb-2">
                            <div class="col-md-12 text-center">No Comment Available</div>
                        </div>
                    </template>
                </b-card-body>
            
                
            </b-card>

        
    </div>
    </b-overlay> <!-- Rejwan: 05-02-2026 Comment Mail Sending -->
</template>


<script>

    import moment from 'moment';
    export default{
            
            props: ['pageurl','ref_id','module','company_id'],
            data(){  
                const now = new Date()
                const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
                const minDate = new Date(today);
    
                return {  
                   
                    showoverlaythread:false,
                    discussions:[],
                    fdata:{ref_id:this.ref_id,module:this.module,comment:''},
                    upload_file : [],
                    showoverlaymodal : false, // Rejwan: 05-02-2026 Comment Mail Sending
                }
            },

        methods:
        {
            download_file_new(file_name)
            {
                let fileURL = this.pageurl + '/images/employee/' +this.company_id+'/'+file_name;
                //alert(fileURL);
                this.download_file(fileURL);

            },
            resetForm()
            {
                this.fdata = {ref_id:this.ref_id,module:this.module,comment:''}; 
                this.upload_file = [];  
            },  
            formatNames(files) {
                return files.length === 1 ? files[0].name : `${files.length} files selected`;
            },
            getDiscussionThread: function()
            { 
                
                let currentObj = this;
                axios.get(this.pageurl+'/discuss' , {
                    params: {
                    module:this.module,
                    ref_id:this.ref_id,
                    }
                }).then(function (response) {
                    currentObj.discussions = response.data;


                    // var messageBody = document.querySelector('#messageBody');
                    // messageBody.scrollTop = messageBody.scrollHeight;
                    
                })  
                .catch(function (error) {
                console.log(error);
                });
                
            }, 
            formatMe(d)
            {
               return moment(d).format('MMMM D, Y');
            },
            
            formatTime (d)
            {
                return moment(d).format('hh:mm:ss A');
            },

            fieldChange(e) {
         

                let selectedFiles = e.target.files;
                this.upload_file = [];
                if (!selectedFiles.length) {
                    return false;
                }
                var name = '';
                var extensions = ["jpg", "png", "gif", "pdf" , "doc" , "docx"];
                for (let i = 0; i < selectedFiles.length; i++) {

                    name = selectedFiles[i].name;
                    var fileExt = name.split('.').pop();
                    fileExt = fileExt.toLowerCase();
                    if (extensions.indexOf(fileExt) < 0) {
                    
                        this.$bvToast.toast('Uploaded file is not supported', {
                                title: `Error`,
                                variant: 'danger',
                                solid: true
                            }); 

                            this.upload_file = [];

                            return;
                    }

                    this.upload_file.push(selectedFiles[i]);
                }

                console.log('upload_file');
                console.log(this.upload_file);
            },
		      
            onSubmitThread(e){

                    this.showoverlaymodal = true; // Rejwan: 05-02-2026 Comment Mail Sending
                    if(!this.checkNet()) return false;
                    this.warningmsg = null; 
                    this.successmsg = null;
                
                    this.showoverlaythread = true;

                    e.preventDefault();
                    let currentObj = this;
                    const config = {
                        headers: { 'content-type': 'multipart/form-data' }
                    }

                    let formData = new FormData();

                    if(this.upload_file)
                    {
                        this.upload_file.forEach(file => {
                            formData.append("upload_file[]", file)
                            })
                    }
                   
                    for (let [key, value] of Object.entries(this.fdata)) 
                    {                    
                        var nm = `${key}`;
                        var fval = `${value}`;
                        formData.append(nm, fval);
                    }


                    axios.post(this.pageurl + '/discuss', formData, config)
                    .then(function (response) 
                    {
                        this.$bvToast.toast('Saved!', {
                                title: `Success`,
                                variant: 'success',
                                solid: true
                            });

                        this.resetForm();
                        this.getDiscussionThread();

                        this.showoverlaythread = false; 
                        this.showoverlaymodal = false; // Rejwan: 05-02-2026 Comment Mail Sending

                    }.bind(this))
                    .catch(function (error) 
                    {
                        this.showoverlaythread = false;  
                        this.showoverlaymodal = false; // Rejwan: 05-02-2026 Comment Mail Sending
                        currentObj.serverError(error);
                        currentObj.errormsg = error.response.data.errors;
                    });
                    

            },
            // Start: Rejwan: 23-06-2026
            onImgError(e) {
                if (e.target.dataset.fallback) return;
                e.target.dataset.fallback = '1';
                e.target.src = this.pageurl + '/images/users/default.png';
            }
            // End: Rejwan: 23-06-2026
        },
        created: function()
        {
            this.getDiscussionThread();
        }    
    }

    </script>
    <style>
    .dir-rtl {
        direction: rtl;
    }
    .dir-ltr
    {
        direction: ltr;
    }
    .card-body.comment-card-body {
        padding: 0;
    }
    .icon_download_link {
	height: 30px;
	display: block;
	width: 23px;
    }
    .custom_font
    {
        font-size:12px;
        font-weight:300;
        color:#696565;
    }
    .attachement_font
    {
        font-size:12px;
        font-weight:300;
    }
    .overlay-posisition {
        position: unset !important
    }
    </style>
